import ArticleAPI from '~/api/articleApi';
import {Fragment, useEffect, useState} from "react";
import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import {format} from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";
import WelcomeToSession from "~/pages/default-apps/Home/components/WelcomeToSession";
import Skeleton from "react-loading-skeleton";
function ArticlePage(){
    const [recentArticles, setRecentArticles] = useState([]);
    const [articles, setArticles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const {getImageUrlById} = useAssetsImage();
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const defaultAvatar = getImageUrlById(63);
    useEffect(() => {
        ArticleAPI.getRecent(3)
            .then((res) => {
                setLoading(false);
                res.data?.forEach(item => {
                    item.RoutePath = 'article/' + item.RoutePath;
                })
                setRecentArticles(res.data);
            })
            .catch((error) => {
                console.error(error);
            })
    }, [])

    useEffect(() => {
        const params = new URLSearchParams({
            PageSize: 6,
            PageNumber: currentPage,
        });
        ArticleAPI.getPaged(params)
            .then((res) => {
                setLoading2(false);
                res.data?.Results.forEach(item => {
                    item.RoutePath = 'article/' + item.RoutePath;
                })
                setArticles(res.data.Results);
                setTotalPages(Math.ceil(res.data.TotalRecord / 6))
            })
            .catch((error) => {
                console.error(error);
            })
    }, [currentPage]);

    const handlePageClick = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const handleShortText = (text) => {
        const maxLength = 70;
        return text.slice(0, maxLength) + "...";
    }

    return (
        <Fragment>
            <WelcomeToSession screen="Article"/>
            <section id="category-section" className="category-section section">
                <div className="container-medium">
                <div className="row">
                    <div className="mb-4 text-center text-sm-start col-12"><h4
                        className="text-primary fw-bolder mb-3">Blog</h4></div>
                    <div className="text-center text-sm-start col-lg-6"><p>Explore our latest articles on AI chatbots in philosophy, where technology meets critical thinking. All posts are organized in one place, helping readers easily discover insights, concepts, and discussions that matter.</p></div>
                    <div className="text-center text-sm-start col-lg-6"><p>Here, we help readers understand key concepts, principles, and practical knowledge, making it easier to learn how AI chatbots can support philosophical exploration and education.</p></div>
                </div>
                <div className="aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                    {
                        loading && (
                            <div className="mt-4">
                                <Skeleton height={40} width={300} />
                                <Skeleton height={200} width="100%" />
                                <Skeleton count={3}/>
                            </div>
                        )
                    }
                    {
                        !loading && (
                            <div className="row gy-4 mb-4">
                                {recentArticles.map((item, index) => (
                                    <div className="col-lg-4" key={index}>
                                        <article className="featured-post">
                                            <div className="post-img">
                                                <img src={item.ThumbnailUrl} alt="" className="img-fluid rounded-3" loading="lazy"/>
                                            </div>
                                            <div className="post-content mt-3">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <span className="text-uppercase text-danger">{item.ArticleTypeName}</span>
                                                    <div className="fs-9">
                                                        {
                                                            getImageUrlById(63) &&
                                                            <img src={defaultAvatar} alt="" width="30px" className="author-img me-1"/>
                                                        }
                                                        <span className="author-name">Break Through - </span>
                                                        <span className="post-date">{format(item.ModifiedDate, 'd MMMM yyyy')}</span>
                                                    </div>
                                                </div>
                                                <h4 className="title">
                                                    <a className="text-primary" target="_blank" href={item.RoutePath}>{item.Title}</a>
                                                </h4>
                                                <p className='fs-8-1'>
                                                    {item.Description}
                                                </p>
                                            </div>
                                        </article>
                                    </div>
                                ))}
                            </div>
                        )
                    }

                    <div className="row">
                        {
                            loading2 && (
                                <div className="mt-4">
                                    <Skeleton height={40} width={300} />
                                    <Skeleton height={200} width="100%" />
                                    <Skeleton count={3}/>
                                </div>
                            )
                        }
                        {
                            !loading2 && (
                                articles.map((item, index) => (
                                    <div className="col-xl-4 col-lg-6" key={index}>
                                        <article className="d-flex align-items-start gap-4 mb-5">
                                            <div className="post-img" style={{flex: "0 0 100px"}}>
                                                <img src={item.ThumbnailUrl} alt="" width="100px" style={{height: "100px"}} className="img-fluid object-fit-cover rounded-3" loading="lazy"/>
                                            </div>
                                            <div className="post-content">
                                                <div className="category-meta">
                                                    <span className="text-danger">{item.ArticleTypeName}</span>
                                                </div>
                                                <h5 className="title">
                                                    <a target="_blank" href={item.RoutePath}>{item.Title}</a>
                                                </h5>
                                                <p className="fs-8-1 mb-0">
                                                    {handleShortText(item.Description)}
                                                    {
                                                        item.Description.length > 0 && (
                                                            <a className="text-primary text-decoration-underline" target="_blank" href={item.RoutePath}>read more</a>
                                                        )
                                                    }
                                                </p>
                                                <div className="fs-9 fw-bold">
                                                    <span className="me-3">Break Through</span>
                                                    <span className="post-date">{format(item.ModifiedDate, 'd MMMM yyyy')}</span>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                ))
                            )
                        }
                    </div>
                </div>
                {
                    totalPages > 0 && (
                        <div className="d-flex align-items-center justify-content-center mt-6" data-list>
                            <button
                                className="page-link"
                                data-list-pagination="prev"
                                disabled={currentPage === 1}
                                onClick={() => handlePageClick(currentPage - 1)}
                            >
                                <ChevronLeft size={16} className={currentPage === 1 ? "opacity-50" : ""}/>
                            </button>

                            <ul className="mb-0 pagination">
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                    <li key={page} className={`page-item ${page === currentPage ? "active" : ""}`}>
                                        <button
                                            type="button"
                                            className="page"
                                            onClick={() => handlePageClick(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}
                            </ul>

                            <button
                                className="page-link pe-0"
                                data-list-pagination="next"
                                disabled={currentPage === totalPages}
                                onClick={() => handlePageClick(currentPage + 1)}
                            >
                                <ChevronRight size={16} className={currentPage === totalPages ? "opacity-50" : ""}/>
                            </button>
                        </div>
                    )
                }
                </div>
            </section>
        </Fragment>
    )
}

export default ArticlePage;